export const NEW_SCREENS = {
  COMPANY: { name: "company", path: "/company" },
  SETTINGS: { name: "settings", path: "/settings" },
  REPORTS: { name: "reports", path: "/reports" },
  BILLING: { name: "billing", path: "/billing" },
  INTEGRATIONS: { name: "integrations", path: "/integrations" },
  ACCOUNT: { name: "account", path: "/account" },
  PROFILE: { name: "profile", path: "/profile" },
  BLOCKED: { name: "Blocked Contacts", path: "/blocked" },
};

export const SPECIAL_ACCESS_SCREENS = ["billing", "reports", "VIP Contacts"];
